// remove inline styles that come from CMS
const styleNodes = document.querySelectorAll('.module style');
Array.prototype.forEach.call(styleNodes, node => node.remove());

const TOCContainer = document.querySelector('.TOC-container');
const privacyCenterTOC = document.querySelector('.privacy-center-TOC');
if (TOCContainer && privacyCenterTOC) {
  window.addEventListener('scroll', () => {
    const topPosition = TOCContainer.getBoundingClientRect().top;

    const containerWidth = parseInt(TOCContainer.clientWidth, 10) - 24; // Remove the 12px padding of the parent width

    if (topPosition < 10) {
      privacyCenterTOC.classList.add('fixed');
      privacyCenterTOC.style.width = `${containerWidth}px`;
    } else {
      privacyCenterTOC.classList.remove('fixed');
      privacyCenterTOC.style.width = '';
    }
  });
}
